import { InputStateToken, InputTypeToken, TextInputTypeToken, WIDGET, } from '@voltmoney/schema';
export const args = {
    onChangeText(text) {
        console.warn(WIDGET.INPUT, '->', text);
    },
    title: 'Title',
    // charLimit:2,
    // charLimitVisiblity:true,
    //limitLabel:"/1000",
    state: InputStateToken.DEFAULT,
    caption: { success: 'Success', error: 'Error' },
    type: InputTypeToken.DEFAULT,
    isFocus: true,
};
export const argTypes = {
    width: {
        control: 'select',
        options: [
            ...Object.values(TextInputTypeToken).filter((k) => typeof k === 'string'),
        ],
    },
    type: {
        control: { type: 'radio' },
        options: [
            ...Object.values(InputTypeToken).filter((k) => typeof k === 'string'),
        ],
    },
    state: {
        control: { type: 'radio' },
        options: [
            ...Object.values(InputStateToken).filter((k) => typeof k === 'string'),
        ],
    },
};
